import { createContext } from "react";

export interface BreadcrumbContextValue {
  overrides: Record<string, string>;
  setOverrides: (overrides: Record<string, string>) => void;
}

export const BreadcrumbContext = createContext<BreadcrumbContextValue>({
  overrides: {},
  setOverrides: () => {},
});
